import commonService from './commonService';
import config from '../config';
import masterListService from '../services/masterListService';


const categoryMasterService = {
    getMasterData,
    getMainCodes,
    saveUpdateDeleteMasterInfo,
    editMasterById,
    getImpaCategories,
    getUOMCodes    
};


function getMasterData(transactionId){
    return commonService.restCall({
      url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
      method:'POST',
      headers:[
            { moduleId: 1 },
            { transactionId },
            { CategoryId: 1 },
        ],
        data:{}
    });
};

function saveUpdateDeleteMasterInfo(payload, transactionId){

    return commonService.restCall({
        url: `${config.apiUrl}${config.snapshot.saveUpdateDeleteMasterInfo}`,
        method: 'POST',
        headers:[
            { moduleId: 1 },
            { transactionId: transactionId },
            { CategoryId: 1 },
        ],
        data:payload
    })
};

function editMasterById(payload, transactionId){

    return commonService.restCall({
        url: `${config.apiUrl}${config.snapshot.getMasterRecord}`,
        method: "POST",
        data:payload,
        headers:[
            { moduleId: 1 },
            { transactionId: transactionId },
            { CategoryId: 1 },
        ],
    })
};


function getMainCodes(transactionId){
    return masterListService.getMainCodes(transactionId);
};

function getImpaCategories(){
    return commonService.restCall({
        url: `${config.apiUrl}iPMS-Master-0.0.1-SNAPSHOT/impacategory/getAllIMPACategorys`,
        method: 'GET',
        headers:[
            { moduleId: 1 },
            { transactionId: 9 },
            { CategoryId: 1 },
        ]
    })
};

function getUOMCodes(){
    return masterListService.getUOMCodes();
};



export default categoryMasterService;
